<template>
  <v-container fluid fill-height class="white">
    <v-layout align-center justify-center>
      <v-flex>
        <v-form v-model="valid" ref="loginform" @submit.prevent="login">
          <v-card
            :class="{ 'mx-auto': true, shake: shaking }"
            elevation="1"
            max-width="1000"
          >
            <v-row>
              <v-col cols="12" md="7" class="d-flex justify-center"
                ><img
                  class="px-4"
                  src="@/assets/LBA-WEB.svg"
                  alt=""
                  style="max-width: 500px"
                />
              </v-col>
              <v-col
                cols="12"
                md="5"
                class="grey lighten-4"
                style="height: 400px"
              >
                <v-container fluid fill-height>
                  <v-layout align-center justify-center>
                    <v-flex>
                      <v-card-title
                        class="justify-center"
                        style="
                          font-size: 2.3em;
                        "
                      >
                        <v-container class="d-flex justify-center align-center">
                          LBA-WEB
                          <VersionChip class="ml-3" color="primary" small />
                        </v-container>
                      </v-card-title>
                      <v-card-text class="pt-5">
                        <div class="d-flex justify-center">
                          <v-text-field
                            v-model="userId"
                            :rules="userIdRules"
                            label="UserID"
                            required
                            prepend-inner-icon="mdi-account"
                            minlength="3"
                            @keyup.enter="login"
                            style="max-width: 400px"
                            solo
                            class="input-field"
                          ></v-text-field>
                        </div>
                        <div class="d-flex justify-center">
                          <v-text-field
                            v-model="password"
                            label="Passwort"
                            required
                            solo
                            prepend-inner-icon="mdi-lock"
                            :append-icon="
                              showPassword ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            :type="showPassword ? 'text' : 'password'"
                            @click:append="showPassword = !showPassword"
                            @keyup.enter="login"
                            style="max-width: 400px"
                          ></v-text-field>
                        </div>

                        <div class="d-flex justify-center">
                          <v-btn
                            v-if="locked_out == true"
                            form="loginform"
                            color="primary"
                            elevation="0"
                            @click="login"
                            :loading="loading"
                            @keydown.enter.prevent
                            class="px-10"
                            disabled
                            >Login</v-btn
                          >
                          <v-btn
                            v-else
                            form="loginform"
                            type="submit"
                            color="primary"
                            elevation="0"
                            @click="login"
                            :loading="loading"
                            class="px-10"
                            >Login</v-btn
                          >
                        </div>
                        <div
                          class="d-flex justify-center mt-5"
                          v-if="loginFail"
                        >
                          <p v-if="locked_out" class="red--text text-center">
                            Anmeldung wegen zu vielen fehlgeschlagenen Versuchen
                            bis {{ lockedUntil }} gesperrt
                          </p>
                          <p class="red--text text-center">{{ failMessage }}</p>
                        </div>
                      </v-card-text>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import VersionChip from '../../components/core/VersionChip.vue'

export default {
  components: {
    VersionChip
  },
  data: () => ({
    locked_out: false,
    lockedUntil: null,
    valid: false,
    userId: '',
    userIdRules: [v => !!v || 'UserID eingeben'],
    password: '',
    showPassword: false,
    loading: false,
    failMessage: '',
    loginFail: false
  }),
  methods: {
    login() {
      if (this.$refs.loginform.validate()) {
        if (this.locked_out) return

        this.loading = true
        this.$store
          .dispatch('login', {
            userId: this.userId,
            password: this.password
          })
          .catch(error => {
            this.loading = false
            this.loginFail = true
            this.valid = false
            this.$store.state.apps.shaking = true

            if (!error.response) {
              this.failMessage =
                'Der Login ist aufgrund eines unbekannten Fehlers fehlgeschlagen!'
              return (this.errorDialog = true)
            } else if (error.response.status == 401) {
              this.failMessage = 'Falsche UserID oder Passwort!'
            } else if (error.response.status == 403) {
              const blockedUntilJson = error.response.data['blockedUntil']
              const blockedUntilMoment = blockedUntilJson
                ? moment(blockedUntilJson)
                : moment().add(10, 'minutes')
              this.lockedUntil = blockedUntilMoment.format('HH:mm')

              this.failMessage = `Aufgrund zu vieler fehlgeschlagenen Anmeldeversuchen ist die Anmeldung bis ${this.lockedUntil} gesperrt!`

              this.locked_out = true
              setTimeout(() => {
                this.locked_out = false
              }, blockedUntilMoment.diff(moment()).valueOf())
            }
            setTimeout(() => {
              this.$store.state.apps.shaking = false
            }, 750)
          })
      }
    }
  },
  computed: {
    ...mapState({
      shaking: state => state.apps.shaking
    }),
    ...mapGetters(['company', 'loggedIn'])
  },
  mounted() {
    if (this.$route.query.logout) {
      this.$toast.info('Erfolgreich abgemeldet.')
    }
  }
}
</script>

<style scoped>
/* nice grey background-color: #7b7887" */

.shake {
  animation: shake 0.3s infinite;
}

@keyframes shake {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(5px);
  }
  50% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
  100% {
    transform: translateX(0);
  }
}

.theme--light .v-card {
  border-left: 5px solid var(--v-primary-base) !important;
}
</style>
